// ** Third Party Components
import { IconDots } from '@tabler/icons-react'

const VerticalNavMenuSectionHeader = ({ item, index }) => {
  return (
    <li className="navigation-header">
      <span>{item.header}</span>
      <IconDots className="feather-more-horizontal" />
    </li>
  )
}

export default VerticalNavMenuSectionHeader
